<div class="maintenance-dashboard">
  <div class="maintenance-dashboard__header">
    <h1>{{ 'maintenanceDashboard.title' | transloco }}</h1>
    <div class="maintenance-dashboard__filters">
      <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

      <div class="common-drop-down date-height">
        <app-date-filter
          [filter]="dateFilter"
          [isButtonIntervalSelector]="false"
          [disabledIntervals]="disabledIntervals"
          [defaultInterval]="defaultInterval"
          (filterChanged)="onDateFilterChange($event)">
        </app-date-filter>
      </div>
    </div>
  </div>

  <div class="maintenance-dashboard__widgets">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-maintenance-required-widget [selectedFilter]="getSelectedFilterLabel()"></app-maintenance-required-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-total-maintenance-cost-widget [selectedFilter]="getSelectedFilterLabel()"></app-total-maintenance-cost-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-available-assets-widget [selectedFilter]="getSelectedFilterLabel()"></app-available-assets-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-avg-workshop-downtime-widget></app-avg-workshop-downtime-widget>
      </div>
    </div>
  </div>

  <div class="maintenance-dashboard__filters justify-content-end">
    <app-asset-type-filter [alignMenuEnd]="true" [menuMaxHeight]="300" [highlight]="false" (typeChanged)="onAssetTypeFilter($event)"></app-asset-type-filter>
  </div>

  <div class="dashboard-content">
    <div class="dashboard-graphs">
      <div class="row">
        <div class="col-xl-6 col-lg-12">
          <app-work-orders-trend></app-work-orders-trend>
        </div>
        <div class="col-xl-6 col-lg-12">
          <app-maintenance-cost-chart-trend></app-maintenance-cost-chart-trend>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-12">
          <app-parts-inventory-trend></app-parts-inventory-trend>
        </div>
        <div class="col-xl-6 col-lg-12">
          <app-compliance-trend></app-compliance-trend>
        </div>
      </div>
    </div>

    <div class="dashboard-sidebar">
      <app-upcoming-activity-widget [assetTypes]="assetType"></app-upcoming-activity-widget>
    </div>
  </div>
</div>